import { render, staticRenderFns } from "./SingleWhitelabel.vue?vue&type=template&id=b182bad6"
import script from "./SingleWhitelabel.vue?vue&type=script&lang=js"
export * from "./SingleWhitelabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports